import GridTextCell from './GridTextCell';
import GridDateCell from './GridDateCell';
import GridItemsCell from './GridItemsCell';
import GridStatusCell from './GridStatusCell';
import EditorSelectCell from './EditorSelectCell';
import GridSelectCell from './GridSelectCell';
import GridStateCell from './GridStateCell';
import GridAmountCell from './GridAmountCell';
import GridPhoneCell from './GridPhoneCell';
import GridPercentCell from './GridPercentCell';
import GridSelectObjectCell from './GridSelectObjectCell';
import GridMultipleItemsCell from './GridMultipleItemsCell';
import GridEnableCell from './GridEnableCell';
import GridCryptoAmountCell from './GridCryptoAmountCell';
import GridCommissionsCell from './GridCommissionsCell';
import GridUrlCell from './GridUrlCell';
import GridCheckboxCell from './GridCheckboxCell';
import GridEntityCell from './GridEntityCell';
import GridCreateModifyCell from './GridCreateModifyCell';
import GridSelectCombinedCell from './GridSelectCombinedCell';
import GridNumberCell from './GridNumberCell';
import GridArrayCell from './GridArrayCell';
import GridEditableBoolean from './GridEditableBoolean';
import ConversionCell from './ConversionCell';
import GridDateTimeCell from './GridDateTimeCell';
import GridBalanceCell from './GridBalanceCell';
import GridUploadCell from './GridUploadCell';
import GridDiffCell from './GridDiffCell';

const Cells = {
    Text: GridTextCell,
    Date: GridDateCell,
    DateTime: GridDateTimeCell,
    CreateModify: GridCreateModifyCell,
    State: GridStateCell,
    Items: GridItemsCell,
    Select: GridSelectCell,
    Status: GridStatusCell,
    Checkbox: GridCheckboxCell,
    Amount: GridAmountCell,
    Phone: GridPhoneCell,
    Percent: GridPercentCell,
    EditorSelect: EditorSelectCell,
    SelectObject: GridSelectObjectCell,
    Countries: GridMultipleItemsCell,
    Enable: GridEnableCell,
    CryptoAmount: GridCryptoAmountCell,
    CommissionsTotal: GridCommissionsCell,
    Url: GridUrlCell,
    Entity: GridEntityCell,
    SystemRole: GridCheckboxCell,
    SelectCombined: GridSelectCombinedCell,
    Number: GridNumberCell,
    ContextMultiSelect: GridArrayCell,
    StaticMultiSelect: GridArrayCell,
    EditableBoolean: GridEditableBoolean,
    RoleSelect: GridSelectCombinedCell,
    Conversion: ConversionCell,
    Balance: GridBalanceCell,
    Upload: GridUploadCell,
    Diff: GridDiffCell,
};

export default Cells;
